import { Box, Typography } from "@material-ui/core";
import { isNalsarTempEmail } from "Clients/Nalsar/utils";
import { isBacTempEmail } from "Clients/ACCB/utils";
import FormattedMessage from "features/common/TranslatedMessage";
import DisplayContainer from "features/profile/DisplayContainer";
import React from "react";
import { isACCB } from "Routes/Routes";

export default function ProfileInfo({
  classes,
  profile: {
    user: { first_name, last_name, email },
    phone_number,
  },
}) {
  const isTempEmail =
    !!email &&
    (email.startsWith("muthoot_temp_email") ||
      isNalsarTempEmail(email) ||
      isBacTempEmail(email));
  return (
    <Box>
      <DisplayContainer title="Account">
        <Typography component="p" className={classes.th}>
          {isACCB ? "Name" : <FormattedMessage id="user.firstName" />}
        </Typography>
        <Box height="0.3rem" style={{width:"auto !important"}}></Box>

        <Typography component="p" className={classes.td}>
          {isACCB
            ? [first_name, last_name].filter(Boolean).join(" ")
            : first_name}
        </Typography>
        <Box height="1rem"></Box>
        {!isACCB && (
          <>
            <Typography component="p" className={classes.th}>
              <FormattedMessage id="user.lastName" />
            </Typography>
            <Box height="0.3rem"></Box>

            <Typography component="p" className={classes.td}>
              {last_name}
            </Typography>
            <Box height="1rem"></Box>
          </>
        )}
        <Typography component="p" className={classes.th}>
          <FormattedMessage id="user.phoneNumber" />
        </Typography>
        <Box height="0.3rem"></Box>

        <Typography component="p" className={classes.td}>
          {phone_number}
        </Typography>
        <Box height="1rem"></Box>
        <Typography component="p" className={classes.th}>
          <FormattedMessage id="user.email" />
        </Typography>
        <Box height="0.3rem"></Box>

        <Typography component="p" className={classes.td}>
          {!isTempEmail ? email : ""}
        </Typography>
      </DisplayContainer>
    </Box>
  );
}
